import { ReactNode } from "react";

import * as S from "./styles";

import CurrencyInput, { CurrencyInputProps } from "react-currency-input-field";

type Props = CurrencyInputProps & {
  label?: string;
  labelIcon?: ReactNode;
  error?: string;
  inputContainerClassname?: string;
  onCurrencyChange?: (value: number) => void;
};

export function MoneyInput({
  label,
  labelIcon,
  error,
  inputContainerClassname,
  onCurrencyChange,
  id,
  ...rest
}: Props) {
  const Icon = labelIcon;

  const handleValueChange = (value?: number | null) => {
    if (value !== undefined && value !== null && onCurrencyChange) {
      onCurrencyChange(value);
    }
  };

  return (
    <S.Wrapper>
      {label && (
        <S.LabelContainer>
          {Icon && Icon}
          <label htmlFor={id}>{label}</label>
        </S.LabelContainer>
      )}

      <S.InputContainer>
        <S.PreffixContainer>
          <span>R$</span>
        </S.PreffixContainer>
        <CurrencyInput
          {...rest}
          id={id}
          allowDecimals={true}
          allowNegativeValue={false}
          // fixedDecimalLength={2}
          groupSeparator="."
          decimalSeparator=","
          // disableGroupSeparators={true}
          onValueChange={(_, name, values) => {
            handleValueChange(values?.float);
          }}
        />
      </S.InputContainer>
      {error && <small>{error}</small>}
    </S.Wrapper>
  );
}
